/** Navigation helpers for the console route manifest (pure). */

const toRegex = (path) => new RegExp(`^${path.replace(/:[^/]+/g, '[^/]+')}/?$`);

/**
 * The nav entry a pathname belongs to: an exact nav match wins, otherwise the
 * route's `navParent`, otherwise the longest nav path that prefixes it.
 */
export function activeNavPath(pathname, routes) {
  const navs = routes.filter((r) => r.nav !== false);
  const exact = navs.find((r) => r.path === pathname);
  if (exact) return exact.path;
  const route = routes.find((r) => toRegex(r.path).test(pathname));
  if (route && route.navParent) return route.navParent;
  const prefix = navs
    .filter((r) => r.path !== '/' && pathname.startsWith(`${r.path}/`))
    .sort((a, b) => b.path.length - a.path.length)[0];
  return prefix ? prefix.path : '/';
}

/** Group nav routes in manifest order: [{ group, routes }]. */
export function groupNav(routes) {
  const out = [];
  for (const r of routes.filter((x) => x.nav !== false)) {
    let g = out.find((x) => x.group === r.group);
    if (!g) out.push((g = { group: r.group, routes: [] }));
    g.routes.push(r);
  }
  return out;
}
